import { AxiosInstance } from 'axios'

import { PaginateDTO } from '@shared/dto/PaginateDTO'

import { InvoiceProduct } from '@modules/products/types/Products/products'
import {
  CreateInvoiceProductRequest,
  DeleteInvoiceProductByIdRequest,
  FindAllInvoiceProductsRequest,
  UpdateInvoiceProductRequest,
} from '@modules/products/types/Products/requests'

export class ProductsService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async create(data: CreateInvoiceProductRequest): Promise<InvoiceProduct> {
    const response = await this.instance.post(`/invoices/products`, data)

    return response.data
  }

  async delete(data: DeleteInvoiceProductByIdRequest): Promise<InvoiceProduct> {
    const response = await this.instance.delete(`/invoices/products/${data.productId}`)

    return response.data
  }

  async findById(id: string): Promise<InvoiceProduct> {
    const response = await this.instance.get(`/invoices/products/${id}`)

    return response.data
  }

  async findAll(params: FindAllInvoiceProductsRequest): Promise<PaginateDTO<InvoiceProduct>> {
    const response = await this.instance.get(`/invoices/products`, { params })

    return response.data
  }

  async update(data: UpdateInvoiceProductRequest): Promise<InvoiceProduct> {
    const response = await this.instance.put(`/invoices/products/${data.id}`, data)

    return response.data
  }
}

export const productsService = (instance: AxiosInstance) => new ProductsService(instance)
